var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportRankSecond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2146_3428)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2146_3428",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H56V56H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2146_3428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5859 27.0375H32.7728L46.7597 0H35.5728L21.5859 27.0375Z",
    fill: "#006CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5834 13.5195L22.9922 24.3345L24.3922 27.0383H32.7791L34.1791 24.3345L28.5834 13.5195Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6744 33.5653H22.4831V27.0378H33.67V33.5653H33.6744ZM33.6744 24.2422H22.4831C20.9387 24.2422 19.6875 25.4934 19.6875 27.0378V33.5653C19.6875 35.1097 20.9387 36.3609 22.4831 36.3609H33.67C35.2144 36.3609 36.4656 35.1097 36.4656 33.5653V27.0378C36.4665 26.6708 36.395 26.3072 36.2551 25.9679C36.1152 25.6286 35.9097 25.3202 35.6504 25.0605C35.3911 24.8008 35.0831 24.5948 34.744 24.4544C34.4049 24.3139 34.0414 24.2418 33.6744 24.2422Z",
    fill: "#CECED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0675 41.9556C42.0675 49.6819 35.8069 55.9425 28.0806 55.9425C20.3588 55.9425 14.0938 49.6819 14.0938 41.9556C14.0938 34.2294 20.3544 27.9688 28.0806 27.9688C35.8069 27.9688 42.0675 34.2338 42.0675 41.9556Z",
    fill: "#CECED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7044 38.5529C18.5207 38.5529 18.3369 38.5179 18.1619 38.4392C17.4882 38.1504 17.1644 37.3673 17.4269 36.6848C17.4313 36.6761 17.4357 36.6629 17.4357 36.6542C17.4401 36.6323 17.4401 36.6367 17.4532 36.6192C18.0649 35.1647 19.0133 33.8763 20.2205 32.8601C21.4276 31.8439 22.8588 31.129 24.3963 30.7742C24.5494 30.7392 24.7113 30.8136 24.7813 30.9579C24.8513 31.1023 24.8119 31.2729 24.6851 31.3736C22.6419 32.9967 21.0101 35.1842 19.9688 37.6998C19.9688 37.7042 19.9644 37.7086 19.9644 37.7086C19.9644 37.7129 19.9644 37.7129 19.9601 37.7173C19.8157 38.0542 19.5488 38.3123 19.2076 38.4479C19.0501 38.5223 18.8751 38.5529 18.7044 38.5529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7128 27.0375H22.5216L8.53906 0H19.7259L33.7128 27.0375Z",
    fill: "#006CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2245 45.4466H27.5301C28.2695 44.9959 29.5601 44.0991 31.0301 42.6291C32.4083 41.2553 32.8676 38.7484 31.2226 37.0991C30.2689 36.1497 29.1839 35.6641 27.9983 35.6641C25.3776 35.6641 23.1901 37.9828 23.0983 38.0791C23.0414 38.1403 23.0283 38.2366 23.0764 38.3109L24.2576 40.2403C24.2883 40.2884 24.3408 40.3234 24.3976 40.3278C24.4545 40.3366 24.5114 40.3191 24.5551 40.2753C24.5683 40.2622 25.9945 38.9409 27.2458 38.9409C27.7489 38.9409 28.1426 39.1509 28.4489 39.5884C28.6983 39.9428 28.7726 40.3366 28.6764 40.7828C28.1995 42.9178 23.9864 45.3328 23.9426 45.3591C23.9137 45.3762 23.8897 45.4005 23.8729 45.4297C23.856 45.4588 23.8469 45.4917 23.8464 45.5253V48.0497C23.8464 48.1591 23.9339 48.2422 24.0389 48.2422H32.2289C32.3339 48.2422 32.4214 48.1547 32.4214 48.0497V45.6347C32.4191 45.584 32.3974 45.5361 32.3607 45.5011C32.324 45.4661 32.2753 45.4465 32.2245 45.4466Z",
    fill: "#77A2AD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2146_3428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportRankSecond);
export default __webpack_public_path__ + "static/media/report_rank_second.4c3054a12f9430d382bd3ce96acd976e.svg";
export { ForwardRef as ReactComponent };